var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.Show)?_c('div',{staticClass:"item",on:{"click":_vm.onClick}},[_c('div',{on:{"click":function($event){$event.stopPropagation();return _vm.innerClick.apply(null, arguments)}}},[_vm._t("default")],2)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f4b36b4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/overlay.vue
// module id = null
// module chunks = 